import {ICustomer} from "./customer.model";
import {IOrganization} from "./organization.model";

export interface IKala {
    id?: number;
    itemName?: string;
    status?: string;
    code?: string;
    cost?: string;
    unit?: string;
    title?: string;
    type?: string;
    country?: string;
    company?: string;
    year?: string;
    description?: string;
    customer?: ICustomer;
  organization?: IOrganization;

}

export class Kala implements IKala {
    constructor(public id?: number, public itemName?: string, public status?: string,
                public type?: string,
                public title?: string,
                public unit?: string,
                public code?: string,
                public cost?: string,
                public description?: string) {}
}
